import { Country } from '@/models';
import {
  IVendor,
  IVendorData,
  IVendorFieldError,
  IVendorFieldErrorData,
  VENDOR_MAX_ID_LENGTH,
  VENDOR_MAX_NAME_LENGTH,
  VENDOR_MAX_CATEGORY_LENGTH,
  VENDOR_MAX_ADDRESS1_LENGTH,
  VENDOR_MAX_ADDRESS2_LENGTH,
  VENDOR_MAX_ADDRESS3_LENGTH,
  VENDOR_MAX_ADDRESS4_LENGTH,
  VENDOR_MAX_CITY_LENGTH,
  VENDOR_MAX_REGION_LENGTH,
  VENDOR_MAX_POSTAL_CODE_LENGTH,
  VENDOR_MAX_COUNTRY_LENGTH,
  VENDOR_CURRENCY_LENGTH,
  VENDOR_MAX_STATUS_LENGTH,
  VENDOR_MAX_TERMS_LENGTH,
  VENDOR_MAX_TERMS_DESCRIPTION_LENGTH,
  VENDOR_MAX_LANGUAGE_LENGTH,
  VENDOR_MAX_CONTACT_LENGTH,
  VENDOR_MAX_PHONE_LENGTH
} from './vendor.types';

export class Vendor implements IVendor {
  readonly id: string = '';

  readonly name: string = '';
  readonly country: string | Country = '';
  readonly currency: string = '';
  readonly status: string = '';
  readonly terms: string = '';
  readonly terms_description: string = '';

  readonly category: string = '';
  readonly address1: string = '';
  readonly address2: string = '';
  readonly address3: string = '';
  readonly address4: string = '';
  readonly city: string = '';
  readonly region: string = '';
  readonly postal_code: string = '';
  readonly language: string = '';
  readonly contact: string = '';
  readonly phone: string = '';
  readonly email: string = '';
  readonly manually_created: boolean = false;

  constructor(data?: IVendorData) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.currency = data.currency;
      this.terms = data.terms;
      this.terms_description = data.terms_description;

      if (data.country) {
        this.country =
          typeof data.country === 'string'
            ? data.country
            : new Country(data.country);
      }

      if (data.address1) {
        this.address1 = data.address1;
      }

      if (data.address2) {
        this.address2 = data.address2;
      }

      if (data.address3) {
        this.address3 = data.address3;
      }

      if (data.address4) {
        this.address4 = data.address4;
      }

      if (data.city) {
        this.city = data.city;
      }

      if (data.region) {
        this.region = data.region;
      }

      if (data.postal_code) {
        this.postal_code = data.postal_code;
      }

      if (data.category) {
        this.category = data.category;
      }

      if (data.language) {
        this.language = data.language;
      }

      if (data.contact) {
        this.contact = data.contact;
      }

      if (data.phone) {
        this.phone = data.phone;
      }

      if (data.email) {
        this.email = data.email;
      }

      if (data.status) {
        this.status = data.status;
      }

      if (data.manually_created) {
        this.manually_created = data.manually_created;
      }
    }
  }

  validate(): boolean {
    // exist statements to not validate all fields
    // ensure vendor name is valid
    if (!this.name || this.name.length > VENDOR_MAX_NAME_LENGTH) {
      return false;
    }

    if (!this.currency || this.currency.length !== VENDOR_CURRENCY_LENGTH) {
      return false;
    }
    if (!this.terms || this.terms.length > VENDOR_MAX_TERMS_LENGTH) {
      return false;
    }
    if (
      !this.terms_description ||
      this.terms_description.length > VENDOR_MAX_TERMS_DESCRIPTION_LENGTH
    ) {
      return false;
    }
    if (!this.id || this.id.length > VENDOR_MAX_ID_LENGTH) {
      return false;
    }
    // OPTIONAL
    if (this.status && this.status.length > VENDOR_MAX_STATUS_LENGTH) {
      return false;
    }
    if (this.phone && this.phone.length > VENDOR_MAX_PHONE_LENGTH) {
      return false;
    }
    if (this.city && this.city.length > VENDOR_MAX_CITY_LENGTH) {
      return false;
    }
    if (this.region && this.region.length > VENDOR_MAX_REGION_LENGTH) {
      return false;
    }
    if (this.language && this.language.length > VENDOR_MAX_LANGUAGE_LENGTH) {
      return false;
    }
    if (this.contact && this.contact.length > VENDOR_MAX_CONTACT_LENGTH) {
      return false;
    }
    if (
      this.postal_code &&
      this.postal_code.length > VENDOR_MAX_POSTAL_CODE_LENGTH
    ) {
      return false;
    }
    if (this.address1 && this.address1.length > VENDOR_MAX_ADDRESS1_LENGTH) {
      return false;
    }
    if (this.address2 && this.address2.length > VENDOR_MAX_ADDRESS2_LENGTH) {
      return false;
    }
    if (this.address3 && this.address3.length > VENDOR_MAX_ADDRESS3_LENGTH) {
      return false;
    }
    if (this.address4 && this.address4.length > VENDOR_MAX_ADDRESS4_LENGTH) {
      return false;
    }
    if (this.category && this.category.length > VENDOR_MAX_CATEGORY_LENGTH) {
      return false;
    }

    return true;
  }
}

export class VendorFieldError implements IVendorFieldError {
  readonly id: string[] = [];
  readonly currency: string[] = [];
  readonly name: string[] = [];
  readonly country: string[] = [];
  readonly status: string[] = [];
  readonly terms: string[] = [];
  readonly terms_description: string[] = [];

  readonly email: string[] = [];
  readonly phone: string[] = [];
  readonly address1: string[] = [];
  readonly address2: string[] = [];
  readonly address3: string[] = [];
  readonly address4: string[] = [];
  readonly city: string[] = [];
  readonly region: string[] = [];
  readonly postal_code: string[] = [];

  readonly language: string[] = [];
  readonly contact: string[] = [];
  readonly category: string[] = [];

  constructor(data?: IVendorFieldErrorData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.currency) {
        this.currency = data.currency;
      }
      if (data.name) {
        this.name = data.name;
      }
      if (data.country) {
        this.country = data.country;
      }
      if (data.status) {
        this.status = data.status;
      }
      if (data.terms) {
        this.terms = data.terms;
      }
      if (data.terms_description) {
        this.terms_description = data.terms_description;
      }
      if (data.email) {
        this.email = data.email;
      }
      if (data.phone) {
        this.phone = data.phone;
      }

      if (data.address1) {
        this.address1 = data.address1;
      }
      if (data.address2) {
        this.address2 = data.address2;
      }
      if (data.address3) {
        this.address3 = data.address3;
      }
      if (data.address4) {
        this.address4 = data.address4;
      }
      if (data.city) {
        this.city = data.city;
      }
      if (data.region) {
        this.region = data.region;
      }
      if (data.postal_code) {
        this.postal_code = data.postal_code;
      }
      if (data.language) {
        this.language = data.language;
      }
      if (data.contact) {
        this.contact = data.contact;
      }
      if (data.category) {
        this.category = data.category;
      }
    }
  }

  clearErrors(): void {
    this.currency.splice(0, this.currency.length);
    this.name.splice(0, this.name.length);
    this.country.splice(0, this.country.length);
    this.status.splice(0, this.status.length);
    this.terms.splice(0, this.terms.length);
    this.terms_description.splice(0, this.terms_description.length);
    this.email.splice(0, this.email.length);
    this.phone.splice(0, this.phone.length);
    this.address1.splice(0, this.address1.length);
    this.address2.splice(0, this.address2.length);
    this.address3.splice(0, this.address3.length);
    this.address4.splice(0, this.address4.length);
    this.city.splice(0, this.city.length);
    this.region.splice(0, this.region.length);
    this.postal_code.splice(0, this.postal_code.length);
    this.language.splice(0, this.language.length);
    this.contact.splice(0, this.contact.length);
    this.category.splice(0, this.category.length);
    this.id.splice(0, this.id.length);
  }

  static isVendorFieldError(data: IVendorFieldErrorData): boolean {
    if (data.id && Array.isArray(data.id)) {
      return true;
    }
    if (data.currency && Array.isArray(data.currency)) {
      return true;
    }
    if (data.name && Array.isArray(data.name)) {
      return true;
    }
    if (data.country && Array.isArray(data.country)) {
      return true;
    }
    if (data.status && Array.isArray(data.status)) {
      return true;
    }
    if (data.terms && Array.isArray(data.terms)) {
      return true;
    }
    if (data.terms_description && Array.isArray(data.terms_description)) {
      return true;
    }
    if (data.email && Array.isArray(data.email)) {
      return true;
    }
    if (data.phone && Array.isArray(data.phone)) {
      return true;
    }
    if (data.address1 && Array.isArray(data.address1)) {
      return true;
    }
    if (data.address2 && Array.isArray(data.address2)) {
      return true;
    }
    if (data.address3 && Array.isArray(data.address3)) {
      return true;
    }
    if (data.address4 && Array.isArray(data.address4)) {
      return true;
    }
    if (data.city && Array.isArray(data.city)) {
      return true;
    }
    if (data.region && Array.isArray(data.region)) {
      return true;
    }
    if (data.postal_code && Array.isArray(data.postal_code)) {
      return true;
    }
    if (data.language && Array.isArray(data.language)) {
      return true;
    }
    if (data.contact && Array.isArray(data.contact)) {
      return true;
    }
    if (data.category && Array.isArray(data.category)) {
      return true;
    }
    return false;
  }
}
